import { render, staticRenderFns } from "./stockCheck.vue?vue&type=template&id=22c5020e&scoped=true"
import script from "./stockCheck.vue?vue&type=script&lang=js"
export * from "./stockCheck.vue?vue&type=script&lang=js"
import style0 from "./stockCheck.vue?vue&type=style&index=0&id=22c5020e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c5020e",
  null
  
)

export default component.exports